export const projectDropdownI18nDe = {
    projects: "Projekte",
    findProjectPlaceholder: "Projekt finden",
    addNewProject: "Neues Projekt hinzufügen",
};
